import { reaction } from 'mobx';

import { checkIsRegularDirectories } from 'src/shared/utils/check-is-regular-directory';

import type { Item } from '../../../shared/entities/abstract-control-entities';
import { Combobox } from '../../../shared/entities/abstract-control-entities';
import { Label } from '../../../shared/entities/control-entities';
import type { FormStore } from '../entities/form.entity';

import { FormPlugin } from './abstract-form-plugin.entity';

export class ComboboxOnChangePlugin extends FormPlugin {
  connect(form: FormStore): VoidFunction {
    const disposers: VoidFunction[] = [];

    const processItem = (item: Item) => {
      if (item instanceof Combobox && item.onChangeInstructions && item.directory) {
        const itemRefObjectType = item.refObjectType;

        if (!itemRefObjectType) {
          return;
        }

        const directory = item.directory;
        for (const updateField of item.onChangeInstructions.updateField) {
          const fieldId = updateField.fieldId;
          const refObjectAttr = updateField.refObjectAttr;
          const refObjectType = updateField.refObjectType;
          const dependentField = form.fields[fieldId];

          if (!refObjectType || !refObjectAttr) {
            continue;
          }

          const disposer = reaction(
            () => item.value,
            (value) => {
              const currentDirectoryValue = checkIsRegularDirectories(directory)
                ? directory.find((dir) => dir.id === value)
                : directory.find((dirValue) => dirValue[itemRefObjectType]?.id === value)?.[refObjectType];

              if (dependentField instanceof Label) {
                if (currentDirectoryValue) {
                  const dependentFieldDirectoryValue = currentDirectoryValue.data[refObjectAttr];
                  const dependentFieldDirectoryId = currentDirectoryValue.id;

                  if (!dependentFieldDirectoryValue && dependentField.nullValue) {
                    form.onValueChange(dependentField.fieldId, dependentField.nullValue, { control: dependentField });
                  }

                  if (dependentFieldDirectoryValue) {
                    const labelControlValue = {
                      label: dependentFieldDirectoryValue,
                      value: dependentFieldDirectoryId,
                    };

                    form.onValueChange(dependentField.fieldId, labelControlValue, { control: dependentField });
                  }
                } else {
                  form.onValueChange(dependentField.fieldId, null, { control: dependentField });
                  dependentField.clearItem();
                }
              }
            },
            { fireImmediately: true },
          );
          disposers.push(disposer);
        }
      }
    };

    form.processFormFields(processItem);

    return () => {
      disposers.forEach((disposer) => disposer());
    };
  }
}
